import type { InboundAttachment } from '../lib/replies'

/** Links to kept attachments (served from `base`/{ownerId}/{n}); the rest are named but not linked. */
export function AttachmentList({ ownerId, attachments, base }: {
  ownerId: number; attachments: InboundAttachment[]; base: string
}) {
  if (attachments.length === 0) return null
  return (
    <ul className="mt-1 text-xs text-paper-trace space-y-0.5">
      {attachments.map((a) => (
        <li key={a.n}>
          {a.available
            ? <a className="underline" href={`${base}/${ownerId}/${a.n}`} target="_blank" rel="noreferrer">{a.name}</a>
            : <span>{a.name} ({a.skipped === 'too_large' ? 'over 10 MB, not kept' : 'not kept'})</span>}
          {' · '}{Math.max(1, Math.round(a.size / 1024))} KB
        </li>
      ))}
    </ul>
  )
}
